import Slider, { createSliderWithTooltip } from 'rc-slider'
import '../../styles/_rcslider.scss'

export default createSliderWithTooltip(Slider)
